import { render } from "./GenericPageMobile.vue?vue&type=template&id=06ac505e&lang=pug"
import script from "./GenericPageMobile.vue?vue&type=script&lang=ts"
export * from "./GenericPageMobile.vue?vue&type=script&lang=ts"
script.render = render

export default script